import { AgrDataSource } from '@next/core-lib/table-v2';
import { Store } from '@ngrx/store';
import { map, Observable, Subject, take } from 'rxjs';
import { selectFavorites, selectFavoritesLoading } from 'src/app/product/store/selectors';
import { FavoriteSku } from 'src/app/standalone/favorites-star/favorite-sku.model';

export class FavoritesDataSource extends AgrDataSource<FavoriteSku & { hasSalesAreaData: boolean }> {
  private destroy$ = new Subject<void>();

  constructor(private readonly store: Store) {
    super();

    this.store
      .select(selectFavoritesLoading)
      .pipe(take(1))
      .subscribe((loading) => this.loadingSubject.next(loading));
  }

  connect(): Observable<(FavoriteSku & { hasSalesAreaData: boolean })[]> {
    return this.store.select(selectFavorites).pipe(
      take(1),
      map((favoriteSkus) => favoriteSkus.map((favoriteSku) => ({ ...favoriteSku, hasSalesAreaData: this.hasSalesAreaData(favoriteSku) }))),
    );
  }

  disconnect(): void {
    if (!this.destroy$.closed) {
      this.destroy$.next();
      this.destroy$.complete();
    }
  }

  hasSalesAreaData = (favoriteSku: FavoriteSku): boolean => favoriteSku.orderingInformation !== null && favoriteSku.packagingInformation !== null;
}
